var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.823-8.158-2.143 2.058a.629.629 0 0 0 -.241.6v15.11a.614.614 0 0 0 .241.6l2.1 2.054v.455h-10.538v-.439l2.17-2.107c.214-.214.214-.277.214-.6v-12.222l-6.036 15.322h-.812l-7.027-15.322v10.268a1.412 1.412 0 0 0 .392 1.181l2.821 3.42v.455h-8.017v-.455l2.821-3.42a1.367 1.367 0 0 0 .366-1.179v-11.877a1.019 1.019 0 0 0 -.334-.875l-2.514-3.027v-.455h7.795l6.019 13.213 5.294-13.2h7.429z",
    fill: "#91929e",
    transform: "translate(.678 13.601)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic_medium.f6051b2ebb33233b9fcb7629edbc684f.svg";
export { ForwardRef as ReactComponent };